export default __webpack_public_path__ + "static/media/gilroy-medium.6d4fe921.woff2";